export default __webpack_public_path__ + "static/media/thumbnail.4b83080c.png";